/**
 * OrcidLogin component script file
 *
 * @package    Containers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import * as qs from 'query-string';

@withRouter
export default class OrcidLogin extends Component {
    /**
     * PropTypes
     */
    static propTypes = {
        onSuccess: PropTypes.func.isRequired,
        onFailure: PropTypes.func.isRequired,
        clientId: PropTypes.string.isRequired,
        className: PropTypes.string,
        location: PropTypes.object,
        history: PropTypes.object,
        tag: PropTypes.string,
        type: PropTypes.string,
        children: PropTypes.node,
        redirectUri: PropTypes.string,
    };

    /**
     * Default styles
     */
    static defaultStyle = {
        display: 'inline-block',
        background: '#d14836',
        color: '#000',
        width: 190,
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: 2,
        border: '1px solid transparent',
        fontSize: 16,
        fontWeight: 'bold',
        fontFamily: '"Fira Sans Condensed", sans-serif'
    };

    /**
     * Component init
     */
    componentDidMount() {
        const { onSuccess, onFailure, location } = this.props;
        const { code, error, error_description } = qs.parse(location.search);

        if (code) {
            this.resetQuery();
            onSuccess({ code, redirect_uri: window.location.href });
        } else if (error) {
            this.resetQuery();
            onFailure({ error, error_description });
        }
    }

    /**
     * Sign in handler
     *
     * @param e
     */
    signIn(e) {
        e && e.preventDefault(); // to prevent submit if used within form

        this.redirect(this.getAuthLink(this.props.clientId, this.props.redirectUri));
    }

    /**
     * Get orcid oauth code url
     *
     * @param clientId
     * @param redirectUri
     * @returns {string}
     */
    getAuthLink(clientId, redirectUri) {
        return `https://orcid.org/oauth/authorize?${qs.stringify({
            redirect_uri: redirectUri ? redirectUri : window.location.href,
            scope: '/authenticate',
            response_type: 'code',
            client_id: clientId,
        })}`;
    }

    /**
     * Redirect to another url
     *
     * @param link
     */
    redirect(link) {
        window.location.href = link;
    }

    /**
     * Remove query params from current url
     */
    resetQuery() {
        const { location, history } = this.props;
        history.replace(location.pathname);
    }

    /**
     * Render
     *
     * @returns {}
     */
    render() {
        const { tag, type, className, children } = this.props,
            style = className ? {} : this.defaultStyle;

        return createElement(
            tag,
            {
                onClick: this.signIn.bind(this),
                style,
                type,
                disabled: false,
                className,
            },
            children
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/OrcidLogin/OrcidLogin.js